import React, { useEffect, useRef, ReactNode, useCallback } from "react";
import { useDispatch } from "react-redux";
import { logout } from "../store/slices/authSlice";

const AUTO_LOGOUT_MINUTES = 5;
const AUTO_LOGOUT_MS = AUTO_LOGOUT_MINUTES * 60 * 1000;

interface AutoLogoutProps {
  children?: ReactNode;
}

const activityEvents = [
  "mousemove",
  "mousedown",
  "keydown",
  "touchstart",
  "scroll",
];

const AutoLogout: React.FC<AutoLogoutProps> = ({ children }) => {
  const dispatch = useDispatch();
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const resetTimer = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      dispatch(logout());
    }, AUTO_LOGOUT_MS);
  }, [dispatch]);

  useEffect(() => {
    resetTimer();
    activityEvents.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      activityEvents.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, [resetTimer]);

  return <>{children}</>;
};

export default AutoLogout;
